export const enum eAccountRouteNames {
  Account = 'AbpAccount::Menu:Account',
  Login = 'AbpAccount::Login',
  LoginWithRecoveryCode = 'AbpAccount::LoginWithRecoveryCode',
  Register = 'AbpAccount::Register',
  EmailConfirmation = 'AbpAccount::EmailConfirmation',
  LinkLogged = 'AbpAccount::LinkLogged',
  ForgotPassword = 'AbpAccount::ForgotPassword',
  ResetPassword = 'AbpAccount::ResetPassword',
  SendSecurityCode = 'AbpAccount::TwoFactorVerification',
  ManageProfile = 'AbpAccount::MyAccount',
  MySecurityLogs = 'AbpAccount::MySecurityLogs',
  Sessions = 'AbpIdentity::Sessions',
  ConfirmUser = 'AbpAccount::ConfirmUser',
}
